import React from 'react'
import WhatsAppChat from "../components/WhatsAppChat"; // Import the new component

function Foot() {

  // WhatsApp message with blog title and URL
  const whatsappMessage = `Hi! I would like to know more about ${window.location.href}`;
  const whatsappPhoneNumber = "919048648777"; // Replace with your WhatsApp number (e.g., +919876543210)

  return (
   
    <>
  {/* Start Footer */}
  <footer className="ak-footer style-1 footer-bg">
    <div className="ak-height-125 ak-height-lg-50" />
    <div className="ak-footer-container">
      {/* <img
    src="assets/img/bg/footer-bg.png"
    class="footer-bg-img"
    alt="...."
  /> */}
      <div className="container">
        <div className="footer-content">
          <div className="company-info">
            <a className="ak-site_branding" href="/">
              <img src="assets/img/logowhite.png" alt="..." />
            </a>
            <p className="text">
              IFMEDU ACADEMY PRIVATE LIMITED consists of dedicated FM, DM, Business &amp;
              Financial Experts committed to guiding you towards a career growth
              and success.
            </p>
            <div className="social-icon">
              <a href="https://www.facebook.com/ifmeduacademyindia" className="icon">
                <svg
                  width={9}
                  height={15}
                  viewBox="0 0 9 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.60386 14.7891L5.60386 8.40347H7.74638L8.06782 5.91416H5.60386V4.32509C5.60386 3.6046 5.80312 3.1136 6.83746 3.1136L8.15454 3.11306V0.886523C7.92677 0.856924 7.14492 0.789063 6.23492 0.789063C4.3347 0.789063 3.03378 1.94894 3.03378 4.07855L3.03378 5.91416H0.884766L0.884766 8.40347H3.03378L3.03378 14.7891H5.60386Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/ifmeduacademyindia/" className="icon">
                <svg
                  height={15}
                  viewBox="0 0 128 128"
                  width={15}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="white"
                >
                  <g>
                    <path d="m16.452 47.708h20.914v62.915h-20.914z" />
                    <path d="m27.048 17.377c-7.155 0-11.838 4.695-11.838 10.868 0 6.041 4.545 10.877 11.562 10.877h.141c7.293 0 11.832-4.836 11.832-10.877-.138-6.173-4.539-10.868-11.697-10.868z" />
                    <path d="m88.706 46.229c-11.11 0-16.075 6.116-18.853 10.396v.204h-.135c.039-.064.096-.138.135-.204v-8.917h-20.916c.279 5.904 0 62.915 0 62.915h20.917v-35.137c0-1.884.141-3.754.693-5.1 1.515-3.761 4.954-7.65 10.734-7.65 7.569 0 10.597 5.772 10.597 14.227v33.661h20.914v-36.079c-.001-19.325-10.319-28.316-24.086-28.316z" />
                  </g>
                </svg>
              </a>
              <a href="https://www.instagram.com/ifmeduacademyindia" className="icon">
                <svg
                  width={15}
                  height={15}
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_77_259)">
                    <path
                      d="M10.7298 0.789062H4.3092C2.21954 0.789062 0.519531 2.48907 0.519531 4.57873V10.9995C0.519531 13.089 2.21954 14.789 4.3092 14.789H10.7299C12.8195 14.789 14.5195 13.089 14.5195 10.9995V4.57873C14.5195 2.48907 12.8195 0.789062 10.7298 0.789062ZM13.6988 10.9995C13.6988 12.6365 12.3669 13.9683 10.7298 13.9683H4.3092C2.6721 13.9683 1.34027 12.6365 1.34027 10.9995V4.57873C1.34027 2.94163 2.6721 1.6098 4.3092 1.6098H10.7299C12.3669 1.6098 13.6988 2.94163 13.6988 4.57873V10.9995Z"
                      fill="white"
                    />
                    <path
                      d="M7.51942 3.96094C5.40861 3.96094 3.69141 5.67814 3.69141 7.78895C3.69141 9.89975 5.40861 11.617 7.51942 11.617C9.63022 11.617 11.3474 9.89975 11.3474 7.78895C11.3474 5.67814 9.63022 3.96094 7.51942 3.96094ZM7.51942 10.7962C5.86128 10.7962 4.51214 9.44719 4.51214 7.78895C4.51214 6.13081 5.86128 4.78168 7.51942 4.78168C9.17766 4.78168 10.5267 6.13081 10.5267 7.78895C10.5267 9.44719 9.17766 10.7962 7.51942 10.7962Z"
                      fill="white"
                    />
                    <path
                      d="M11.4392 2.60156C10.8155 2.60156 10.3081 3.10902 10.3081 3.73269C10.3081 4.35647 10.8155 4.86393 11.4392 4.86393C12.063 4.86393 12.5705 4.35647 12.5705 3.73269C12.5705 3.10892 12.063 2.60156 11.4392 2.60156ZM11.4392 4.04309C11.2681 4.04309 11.1288 3.90381 11.1288 3.73269C11.1288 3.56148 11.2681 3.4223 11.4392 3.4223C11.6105 3.4223 11.7497 3.56148 11.7497 3.73269C11.7497 3.90381 11.6105 4.04309 11.4392 4.04309Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_77_259">
                      <rect
                        width={14}
                        height={14}
                        fill="white"
                        transform="translate(0.519531 0.789062)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </a>
        <a href="https://www.youtube.com/@ifmeduacademyindia/featured" className="icon">
  <svg
    width={15}
    height={15}
    viewBox="0 0 28.57 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M27.9727 3.12324C27.6435 1.89323 26.6768 0.926623 25.4468 0.597366C23.2197 2.24288e-07 14.285 0 14.285 0C14.285 0 5.35042 2.24288e-07 3.12323 0.597366C1.89323 0.926623 0.926623 1.89323 0.597366 3.12324C2.24288e-07 5.35042 0 10 0 10C0 10 2.24288e-07 14.6496 0.597366 16.8768C0.926623 18.1068 1.89323 19.0734 3.12323 19.4026C5.35042 20 14.285 20 14.285 20C14.285 20 23.2197 20 25.4468 19.4026C26.6768 19.0734 27.6435 18.1068 27.9727 16.8768C28.5701 14.6496 28.5701 10 28.5701 10C28.5701 10 28.5677 5.35042 27.9727 3.12324Z" fill="#fff"></path>
    <path d="M11.4253 14.2854L18.8477 10.0004L11.4253 5.71533V14.2854Z" fill="black"></path>
  </svg>
</a>
            </div>
          </div>
          <div className="footer-nav">
            {/* <div className="new-letter-email">
              <div className="new-letter">
                <h5 className="title">Newsletter Signup</h5>
                <p className="desp">
                  Empowering Learners with Knowledge, Strategy, and Impact
                </p>
              </div>
              <form className="email-content">
                <div className="email-input-btn">
                  <input
                    className="email"
                    type="text"
                    name="fristname"
                    placeholder="Enter Your Email Address..."
                  />
                  <button type="submit" className="common-btn style-2 type-2">
                    <span className="arrow-cricle">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={15}
                        height={15}
                        viewBox="0 0 15 15"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_201_9785345)">
                          <path
                            d="M1.42236 6.99728H13.089M13.089 6.99728L7.48903 1.39728M13.089 6.99728L7.48903 12.5973"
                            stroke="#030917"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_201_9785345">
                            <rect
                              width={14}
                              height={14}
                              fill="white"
                              transform="translate(0.00927734)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={15}
                        height={15}
                        viewBox="0 0 15 15"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_201_97834)">
                          <path
                            d="M1.42236 6.99728H13.089M13.089 6.99728L7.48903 1.39728M13.089 6.99728L7.48903 12.5973"
                            stroke="#030917"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_201_97834">
                            <rect
                              width={14}
                              height={14}
                              fill="white"
                              transform="translate(0.00927734)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                  </button>
                </div>
                <p className="text">Stay updated with our advisory</p>
              </form>
            </div> */}
            <div className="footer-link">
              <div className="link-content">
                <h5 className="short-title">About Us</h5>
                <ul className="linek-all">
                  <li>
                    <a href="/about">About</a>
                  </li>
                  <li>
                    <a href="/contacts">Contact Us</a>
                  </li>
                  <li>
                    <a href="/education-career-counselling">Counselling</a>
                  </li>
                  <li>
                    <a href="/accreditations">Accreditations</a>
                  </li>
                  <li>
                    <a href="/awards">Awards</a>
                  </li>
                  <li>
                    <a href="/verify-certificate">Verify Certificate</a>
                  </li>
                  <li>
                    <a href="/photo-gallery">Photo Gallery</a>
                  </li>
                  <li>
                    <a href="/video-gallery">Video Gallery</a>
                  </li>
                   <li>
                    <a href="/terms-and-conditions">Terms & Conditions</a>
                  </li>
                    <li>
                    <a href="/privacy-policy">Privacy Policy</a>
                  </li>
                     <li>
                    <a href="/refund-policy">Refund Policy</a>
                  </li>
                </ul>
              </div>
              <div className="link-content">
                 <h5 className="short-title">India Office</h5>
                <ul className="linek-all">
                  <li>
                    <a href="#" className="mb-3">
                      IFMEDU ACADEMY PRIVATE LIMITED, <br/>VSK TOWER, OPP. TVS Jn,
                      <br />
                      Ernakulam, Kerala - 682019
                    </a>
                  </li>
                  {/* <li>
                    <a href="#" className="mb-3">
                      UAE : Post box : 71684, Dubai,
                      <br /> United Arab Emirates.
                    </a>
                  </li> */}
                  <li>
                    <a href="tel:+91 90486 48777" className="mb-3">
                      <span className="ak-font-20">Phone: </span>
                      <br />
                      +91 90486 48777
                    </a>
                  </li>
                  <li>
                    <a href="mailto:enquiry@ifmedu.in">
                      <span className="ak-font-20">Email: </span>
                      <br />
                      enquiry@ifmedu.in
                    </a>
                  </li>
                </ul>
              </div>
              <div className="link-content">
                <h5 className="short-title">UAE Office</h5>
                <ul className="linek-all">
             
                  <li>
                    <a href="#" className="mb-3">
                      Post box : 71684, Dubai,
                      <br /> United Arab Emirates.
                    </a>
                  </li>
                  <li>
                    <a href="tel:+971557430717" className="mb-3">
                      <span className="ak-font-20">Phone: </span>
                      <br />
                      +971 55 7430 717
                    </a>
                  </li>
                  <li>
                    <a href="mailto:enquiry@ifmedu.org">
                      <span className="ak-font-20">Email: </span>
                      <br />
                      enquiry@ifmedu.org
                    </a>
                  </li>
                </ul>
              </div>



            </div>
          </div>
        </div>
      </div>
      <div className="ak-height-100 ak-height-lg-50" />
    </div>
    <div className="copy-right">
      <p className="copyright-text">
        Copyright © 2010-2025 IFMEDU ACADEMY PRIVATE LIMITED. All Rights Reserved. Powered by
        <a href="https://daddycool.tech"> DC</a>
      </p>
    </div>
  </footer>

  {/* Add WhatsApp chat button */}
      <WhatsAppChat phoneNumber={whatsappPhoneNumber} message={whatsappMessage} />

  {/* End Footer */}
  <span className="ak-scrollup">
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 10L1.7625 11.7625L8.75 4.7875V20H11.25V4.7875L18.225 11.775L20 10L10 0L0 10Z"
        fill="currentColor"
      />
    </svg>
  </span>
</>


  )
}

export default Foot